import { initReporterInstance } from './core/tracerProvider';
import { setMetricPrefix } from './metrics/creates';
import { setKnownRoutes } from './route';
import { initWebVitalsReporting } from './webVitals';
import { initResourceMetrics } from './resourceMetrics';
import { initErrorTracking } from './errorTracking';
import { trackSession, trackPageView } from './pageTracking';

let initialized = false;

export function initShopeepayReporter(config) {
  if (initialized) {
    console.warn('[@shopeepay/reporter] Already initialized, skipping.');
    return initReporterInstance(config);
  }
  initialized = true;

  setMetricPrefix(config.metricPrefix || 'spp');
  setKnownRoutes(config.knownRoutes);

  const reporter = initReporterInstance(config);

  initWebVitalsReporting();
  initResourceMetrics();
  initErrorTracking(config.maxErrorsPerSession);

  trackSession(config.sessionStorageKey || 'spp_session');
  trackPageView();

  // Hash anchor navigation (e.g. clicking `<a href="#registration">` on
  // /merchant) doesn't reload the page or fire a popstate, so the initial
  // trackPageView() above won't see it. Listen for hashchange and re-fire
  // so an external link AND an in-page click both produce a pageView with
  // the hash-anchored route label — assuming the site listed it in
  // knownRoutes. (Hashes not on the allowlist fall back to pathname-only,
  // so this is also safe for sites that don't opt in.)
  if (typeof window !== 'undefined') {
    window.addEventListener('hashchange', trackPageView);
  }

  return reporter;
}
